import { render, staticRenderFns } from "./SmsDialog.vue?vue&type=template&id=b1854160&scoped=true&"
import script from "./SmsDialog.vue?vue&type=script&lang=js&"
export * from "./SmsDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1854160",
  null
  
)

export default component.exports